import React, { useContext, useEffect, useState } from "react";
import { Table, Select, Button, Checkbox, Modal, message } from 'antd';
import * as yup from "yup";
import { map } from 'lodash';
import { UsergroupAddOutlined } from '@ant-design/icons';
// import SideBar from './SideBar';
import DataTable from './Datatable';
import axios from "../../../../Lib/axios";
import chevronDown from '../../../../Assets/images/chevron-down.png';
import close from "../../../../Assets/images/close.png";
import StatusOutsideAlerter from "../../../Common/statusOutsideAlerter";
const PageContext = React.createContext();
const { Option } = Select;

export default function CustomerList(props) {
  const [state, setState] = useState({ errors: {} });
  const [customerList, setCustomerList] = useState([]);
  const [customerListStatus, setCustomerListStatus] = useState([]);
  const [confirm, setConfirm] = useState(false);
  return (
    <PageContext.Provider value={{ state, setState, customerList, setCustomerList, customerListStatus, setCustomerListStatus, confirm, setConfirm, clearState: () => { setState({ errors: {} }) }, ...props }}>
      <CustomerList_ />
    </PageContext.Provider>
  )
}

function CustomerList_() {
  const ctx = useContext(PageContext);
  const { state, setState, customerList, setCustomerList, customerListStatus, setCustomerListStatus } = ctx;
  const [statusFilter, setStatusFilter] = useState(false);
  const [serviceOrderCount, setServiceOrderCount] = useState(0);
  const [customerStatus, setCustomerStatus] = useState([]);
  const { reassignFrom, reassignTo, status, ordering, selectedRow, reassignName = "[From Technician]" } = state;
  const filterStatus = [
    { id: 1, key: "Active", value:"active", is_checked: true },
    { id: 2, key: "Pending", value:"pending", is_checked: false },
    { id: 3, key: "Inactive", value:"inactive", is_checked: false },
  ]
  /**
   * AUTHOR: Ritesh Solanki
   */
  useEffect(() => {
    setState(s => ({
      ...s,
      reassignFrom: "",
      reassignTo: "",
      status: ["active"],
      ordering: "",
      selectedRow: []
    }));
    setCustomerStatus(filterStatus);
  }, [])

  /**
   * AUTHOR: Ritesh Solanki
   */
  useEffect(() => {
    let queryString = "";
    if (reassignFrom) {
      queryString = `?preferred_technician__uuid=${reassignFrom}`;
    }
    if (status && status.length > 0 && reassignFrom) {
      queryString = `${queryString}&status__in=${status.join()}`
    }
    if (ordering) {
      queryString = `${queryString}&ordering=${ordering}`
    }
    if (queryString) {
      axios
        .get(`/reassign-technician/${queryString}`)
        .then(response => {
          setServiceOrderCount(response?.data?.count);
          setCustomerList(response?.data?.results);
        })
        .catch(error => {
          console.log(error)
        }
        )
    }

    if (reassignFrom) {
      axios
        .get(`/reassign-technician/?preferred_technician__uuid=${reassignFrom}`)
        .then(response => {
          setCustomerListStatus(response?.data?.results);
        })
        .catch(error => {
          console.log(error)
        }
        )
    }
  }, [state]);
    
  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3485></DP-3485>
   */
  const reAssignServiceOrder = () => {
    const schema = yup.object().shape({
      reassignTo: yup.string().required('Select a technician.'),
      reassignTo_1: (reassignFrom === reassignTo) ? yup.string().required('This technician already owns these customers.') : null
    });
    const data = { reassignTo };
    schema.validate(data, { abortEarly: false }).then(() => {
      if (selectedRow && selectedRow.length > 0) {
        bulkUpdate();
      } else {
        message.error(`You must select at least one customer to transfer.`, 10);
      }
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => { err_data[item.path] = item.message });
      setState(s => ({ ...s, errors: err_data }));
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3287>Bulk Reassign Preferred Technicians, Finalize</DP-3287>
   */
  const bulkUpdate = () => {
    const params = {
      preferred_technician_uuid: reassignTo,
      user_uuids: selectedRow
    }
    axios.patch(`/reassign-technician/bulk-update/`, params).then((response) => {
      message.success(`Customers reassigned`, 10);
      setState(s => ({ 
        ...s,
        reassignFromLocal: "",
        reassignFrom:"",
        reassignTo: "",
        status: [],
        ordering: "",
        selectedRow: [],
        errors: {}
      }));
      setCustomerList([]);
      setCustomerListStatus([]);
    }).catch(error => {
      message.error(`Error occurred while bulk reassigning customers.`, 30);
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3485></DP-3485>
   */
  const toggleStatus = () => {
    if (statusFilter) {
      setStatusFilter(false);
    } else {
      setStatusFilter(true);
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3485></DP-3485>
   */
  const closeStatusFilter = () => {
    setStatusFilter(false);
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3485></DP-3485>
   */
  const onStatusChanged = (is_checked, item, index) => {
    if (is_checked) {
      customerStatus[index]['is_checked'] = true;
      status.push(item.value)
    } else {
      customerStatus[index]['is_checked'] = false
      const ind = status.indexOf(item.value);
      if (ind > -1) {
        status.splice(ind, 1);
      }
    }
    setState(s => ({ 
      ...s, 
      status,
      customerStatus
    }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3286></DP-3286>
   */
  const clearFilter = () => {
    setState(s => ({ ...s, status: [] }));
  }
  
  

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3485></DP-3485>
   */
  const renderStatusFilters =  () => {
    return (
      <StatusOutsideAlerter
        closeStatusFilter={closeStatusFilter}
      >
        <div className="form-group image-input">
          <div className="fitem mb-0">
            <input type="text" placeholder={`Status: ${status ? status.join() : ''}`} onFocus={() => {toggleStatus() }} />
            {status && status.length === 0 && 
                  <img src={chevronDown} alt="" onClick={() => { toggleStatus() }} />
            }
            {status && status.length > 0 && 
                  <img src={close} alt="" onClick={() => { clearFilter() }} />
            }
          </div>
          {statusFilter && <div className="field-dropdown right">
            <div className="field-dropdown-body">
              {map(customerStatus, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <Checkbox
                      defaultChecked={item.is_checked}
                      checked={item.is_checked}
                      // value={item.is_checked}
                      onChange={(e) => {
                        onStatusChanged(e.target.checked, item, index)
                      }}
                    >
                      {item.key}
                    </Checkbox>
                  </div>
                )
              })}
            </div>
          </div>}
        </div>
      </StatusOutsideAlerter>
    )
  }

  return (
    <React.Fragment>
      <div id="container">
        <div className="franchisee">
          <div className="aside-area pt-0">
            { SideBar() }
            <div className={`main pl-0 pr-0 flex-1`}>
              <div className="card">
                <div className="card-title bdr-b-none flex ai-center">
                  <div className="pt-10 pb-10">
                    <h3>Customers</h3>
                    {customerList && customerList.length > 0 &&
                      <p>Viewing customers with a preferred technician of {reassignName}</p>
                    }                    
                  </div>
                  <div className="form-group">
                    { customerListStatus && customerListStatus.length > 0 ? 
                      <div className="fitem half-fitem mb-0">  
                        {renderStatusFilters()}
                        <div className="fitem half-fitem mb-0" style={{textAlign: "right"}}>
                          <Button className="btn btn-brand btn-lg" onClick={() => { reAssignServiceOrder()}} >Reassign Customer</Button>
                        </div>
                      </div> 
                      : ''}
                  </div>
                </div>
                <div className="card-body pl-0 pr-0">
                  <React.Fragment>
                    {customerList && customerList.length > 0 ?  
                      <>
                        <Table
                          rowSelection={{ 
                            type: "select",
                            onChange: (selectedRowKeys) => {
                              setState(s => ({ ...s, selectedRow: selectedRowKeys }));
                            }
                          }}
                          rowKey={record => record.uuid}
                          dataSource={customerList}
                          columns={DataTable.customerColumns(this)}
                          className="tablebody"
                          position={false}
                          //locale={locale}
                          pagination={{ ...{showSizeChanger: false, pageSize: 10, ordering: ""}, total: serviceOrderCount }}
                          onChange={(pagination, filters, sorter) => {
                            let ordering = '';
                            if (sorter.column) {
                              ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
                            } else {
                              ordering = ''
                            }
                            if (ordering) {
                              setState(s => ({ ...s, ordering: ordering }));
                            } else {
                              setState(s => ({ ...s, ordering: '' }));
                            }
                          }}
                        />
                      </>
                      :
                      customerList && customerList.length === 0 && !reassignFrom ?
                        <div style={{textAlign: "center"}}>
                          <UsergroupAddOutlined style={{fontSize: "40px",color: '#feaf32'}} />
                          <p>
                            <strong style={{fontWeight: "bold",marginBottom: "5px"}}> No Customers </strong><br />
                            <span> Customers will appear here when a technician has been selected.</span>
                          </p>
                        </div> 
                        :
                        customerList && customerList.length === 0 && reassignFrom ?
                          <div style={{textAlign: "center"}}>
                            <UsergroupAddOutlined style={{fontSize: "40px",color: '#feaf32'}} />
                            <p>
                              <strong style={{fontWeight: "bold",marginBottom: "5px"}}> No Customers </strong><br />
                              <span> The technician selected has no assigned customers.</span>
                            </p>
                          </div>
                          : ''
                    }
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

function SideBar() {
  const ctx = useContext(PageContext);
  const { state, setState, confirm, setConfirm } = ctx;
  const { reassignFromLocal, errors, selectedRow } = state;
  const [inactiveTechnicians, setInactiveTechnicians] = useState([]);
  const [activeTechnicians, setActiveTechnicians] = useState([]);

  // Reassign From
  useEffect(() => {
    axios
      .get(`/ftech/field-reassign-technicians/ `)
      .then(response => {
        setInactiveTechnicians(response?.data?.results)
      })
      .catch(error => {
        console.log(error)
      })
  }, []);

  // Reassign To
  useEffect(() => {
    axios
      .get(`/ftech/field-reassign-technicians/?user__is_active=true`)
      .then(response => {
        setActiveTechnicians(response?.data?.results)
      })
      .catch(error => {
        console.log(error)
      })
  }, []);

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3486></DP-3486>
   */
  const search = () => {
    const schema = yup.object().shape({
      reassignFromLocal: yup.string().required('Select a technician.'),
    });
    const data = { reassignFromLocal };
    schema.validate(data, { abortEarly: false }).then(() => {
      if (selectedRow && selectedRow.length > 0) {
        setConfirm(true);
      } else {

        let reassignName = "[From Technician]";
        const reassignArr = activeTechnicians.filter((x) => { return x.uuid === reassignFromLocal });
        if (reassignArr && reassignArr.length > 0) {
          reassignName = `${reassignArr[0].user.first_name} ${reassignArr[0].user.last_name}`;
        }
        setState(s => ({ 
          ...s,
          reassignFrom:reassignFromLocal,
          reassignName:reassignName, 
          errors: {}
        }));
      }            
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => { err_data[item.path] = item.message });
      setState(s => ({ ...s, errors: err_data }));
    })
  }

  return ( 
    <aside className="laside">
      <div className="card">
        <div className="card-body">
          <h2>Bulk Reassign Technician</h2>
          <p>Reassign customers from one technician to another</p>
          <div className="form-group">
            <div className="fitem">
              <label>Reassign From<sup>*</sup></label>
              <Select
                showSearch
                placeholder="Search"
                optionFilterProp="children"
                onChange={(e) => {
                  setState(s => ({ ...s, reassignFromLocal: e }))
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={state?.reassignFromLocal || undefined}
              >
                {
                  inactiveTechnicians?.map((technician, index) => {
                    return <Option key={index} value={technician.uuid}>{`${technician?.user?.first_name} ${technician?.user?.last_name}`}</Option>
                  })
                }
              </Select>
              {errors?.['reassignFromLocal'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['reassignFromLocal']}</label> : ''}
            </div>
            <div className="fitem">
              <Button className="btn btn-brand btn-full" onClick={(e) => { search(); }}>Search</Button>
            </div>
            <div className="fitem">
              <label>Reassign To<sup>*</sup></label>
              <Select
                showSearch
                placeholder="Search"
                optionFilterProp="children"
                onChange={(e) => {
                  setState(s => ({ ...s, reassignTo: e }))
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={state?.reassignTo || undefined}
              >
                {
                  activeTechnicians?.map((technician, index) => {
                    return <Option key={index} value={technician.uuid}>{`${technician?.user?.first_name} ${technician?.user?.last_name}`}</Option>
                  })
                }
              </Select>
              {errors?.['reassignTo'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['reassignTo']}</label> : ''}
              {errors?.['reassignTo_1'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['reassignTo_1']}</label> : ''}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="New Search"
        visible={confirm}
        okText={"Search"}
        cancelText={"Cancel"}
        onOk={() => {
          setConfirm(false);
          let reassignName = "[From Technician]";
          const reassignArr = activeTechnicians.filter((x) => { return x.uuid === reassignFromLocal });
          if (reassignArr && reassignArr.length > 0) {
            reassignName = `${reassignArr[0].user.first_name} ${reassignArr[0].user.last_name}`;
          }
          setState(s => ({
            ...s,
            selectedRow: [],
            reassignFrom:reassignFromLocal,
            reassignName:reassignName,
            errors: {}
          }));
        }}
        onCancel={() => {
          setConfirm(false);
        }}
        className="delete_user_modal"
        width={400}
      >
        <h3>New Search</h3>
        <p>Performing a new search now will clear any progress made so far.</p>
        <p>Would you like to continue?</p>
      </Modal>
    </aside> 
         
  )
}
